import {gql} from '@apollo/client';

export const GET_CLUBS_FOR_ADMIN = gql`
  query getClubsForAdmin($limit: Int, $offset: Int) {
    getClubs(limit: $limit, offset: $offset) {
      id
      name
      email
      address
      city
      state
      contactPersonName
      contactPersonNumber
      useGoldProfitsForAllShelves
      profitPercentageApproved
      offerDiscountPercentage
      isAvailable
      isSuspended
      availabilityMessage
      suspension {
        source
        startDate
        endDate
        reason
      }
      bottleService {
        shelf
        simulatePrice
        numberOfPegs {
          pegCount
          pegTitle
          totalPrice
          actualClubPrice
          validity
          customerPrice
          platformFee
          gst
          mrp
          discountPercentage
          profitPercentage
          profitAmount
        }
      }
      alcoholList {
        name
        shelf
        type
        isAvailable
      }
    }
  }
`;

export const GET_VENUE_OFFLINE_REQUESTS = gql`
  query getVenueOfflineRequests {
    getVenueOfflineRequests {
      id
      clubId
      venueName
      venueEmail
      startDate
      endDate
      reason
      createdAt
      actualStartDate
      actualEndDate
      offlineDays
      offlineWeekdays
      submittedAt
      enabledAt
    }
  }
`;

export const GET_CLUB_BOTTLE_SERVICE= gql`
    query getClubDetailsById($clubId: String) {
        getClubById: getClubDetailsById(clubId: $clubId) {
            useGoldDiscountsForAllShelves
            bottleService {
              shelf
              simulatePrice
              numberOfPegs {
                pegCount
                pegTitle
                totalPrice
                actualClubPrice
                validity
                customerPrice
                platformFee
                gst
                mrp
                discountPercentage
                profitPercentage
                profitAmount
              }
            }
        }
    }
`;

export const GET_CLUB_BY_EMAIL= gql`
query getClubByEmail($email: String) {
  getClubByEmail(email: $email) {
    id
    name
    address
    city
    state
    country
    zipCode
    localityArea
    email
    image
    clubImageFileId
    profileImages {
      url
      fileId
    }
    enrolledStatus
    priceIndicator
    eventList
    contactPersonName
    contactPersonNumber
    openingTime
    closingTime
    isAvailable
    isSuspended
    payoutApproved
    profitPercentageApproved
    availabilityMessage
    suspension {
      source
      startDate
      endDate
      reason
    }
    bottleService {
      shelf
      simulatePrice
      numberOfPegs {
        pegCount
            pegTitle
            totalPrice
            actualClubPrice
            validity
            customerPrice
            platformFee
            gst
            mrp
            discountPercentage
            profitPercentage
            profitAmount
      }
    }
    alcoholList {
      name
      image
      shelf
      type
      isAvailable
    }
    happyHours {
      isActive
      offerName
      offerDescription
      offerImage
      offerImageFileId
      offerStartDate
      offerEndDate
      offerStartTime
      offerEndTime
      offerRestrictions
      offerValidDays
      offerValidity
    }
  }
}
`;
